import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContext";
import { getServices, createService, updateService, deleteService } from "../api";

export default function AdminServices() {
    const { token, logout } = useContext(AuthContext);
    const [services, setServices] = useState([]);
    const [error, setError] = useState("");
    const [newService, setNewService] = useState({ name: "", duration: 1 });

    const load = async () => {
        try {
            const data = await getServices();
            setServices(Array.isArray(data) ? data : []);
        } catch (e) {
            if (e.message === "unauthorized") logout();
            else setError("Konnte Services nicht laden.");
        }
    };

    useEffect(() => { load(); }, []);

    const save = async (s) => {
        try {
            await updateService(token, s.id, s);
            load();
        } catch (e) {
            if (e.message === "unauthorized") logout();
            else setError("Speichern fehlgeschlagen.");
        }
    };

    const create = async () => {
        try {
            await createService(token, newService);
            setNewService({ name: "", duration: 1 });
            load();
        } catch (e) {
            if (e.message === "unauthorized") logout();
            else setError("Anlegen fehlgeschlagen.");
        }
    };

    const remove = async (id) => {
        try {
            await deleteService(token, id);
            load();
        } catch (e) {
            if (e.message === "unauthorized") logout();
            else setError("Löschen fehlgeschlagen.");
        }
    };

    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-4">Services verwalten</h2>
            {error && <div className="text-red-600 mb-4">{error}</div>}
            <table className="w-full border">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="p-2 text-left">Name</th>
                        <th className="p-2 text-left">Dauer</th>
                        <th className="p-2"></th>
                    </tr>
                </thead>
                <tbody>
                    {services.map(s => (
                        <tr key={s.id} className="border-t">
                            <td className="p-2">
                                <input
                                    value={s.name}
                                    onChange={e => setServices(services.map(x => x.id === s.id ? { ...x, name: e.target.value } : x))}
                                    className="border p-1 w-full"
                                />
                            </td>
                            <td className="p-2">
                                <input
                                    type="number"
                                    min="1"
                                    value={s.duration}
                                    onChange={e => setServices(services.map(x => x.id === s.id ? { ...x, duration: parseInt(e.target.value) || 1 } : x))}
                                    className="border p-1 w-full"
                                />
                            </td>
                            <td className="p-2 text-right">
                                <button onClick={() => save(s)} className="bg-blue-600 text-white px-3 py-1 rounded">Speichern</button>
                                <button onClick={() => remove(s.id)} className="bg-red-600 text-white px-3 py-1 rounded ml-2">Löschen</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="mt-4">
                <h3 className="font-bold mb-2">Neuen Service anlegen</h3>
                <div className="flex flex-col md:flex-row gap-2">
                    <input
                        value={newService.name}
                        onChange={e => setNewService({ ...newService, name: e.target.value })}
                        placeholder="Name"
                        className="border p-1 flex-1"
                    />
                    <input
                        type="number"
                        min="1"
                        value={newService.duration}
                        onChange={e => setNewService({ ...newService, duration: parseInt(e.target.value) || 1 })}
                        placeholder="Dauer"
                        className="border p-1 flex-1"
                    />
                    <button onClick={create} className="bg-green-600 text-white px-3 py-1 rounded">Hinzufügen</button>
                </div>
            </div>
        </div>
    );
}

